import { QRCodeSVG } from 'qrcode.react';
import { ComponentProps } from 'react';

export const QrCode = (props: Omit<ComponentProps<typeof QRCodeSVG>, 'level'>) => {
  return <QRCodeSVG {...props} level='L' />;
};
